import { CircularProgress } from '@material-ui/core';
import { validationStatusToMessageMap } from 'common/constants/constants';
import {
  LBInput,
  LBCheckIcon,
  LBAlert,
  LBAlertCircleIcon
} from '@linearb/buzz';

const TokenValidator = ({
  token,
  setToken,
  status,
  loading,
  failurePayload,
  disabled = false,
  className = '',
  showMaskedToken = false,
  inputClassName = 'w-full'
}) => {
  const tokenDisabled = disabled || loading;

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <div className='flex gap-2'>
        {showMaskedToken ? (
          <LBInput
            className={inputClassName}
            data-cy='tokenInput'
            disabled={true}
            type='password'
            autoComplete='off'
            name='access-token'
            value='••••••••••••••••••••'
          />
        ) : (
          <>
            <LBInput
              className={inputClassName}
              data-cy='tokenInput'
              disabled={tokenDisabled}
              type='password'
              autoComplete='off'
              name='access-token'
              placeholder='Paste token'
              onChange={e => setToken(e.target.value)}
              value={token}
            />
            {status === validationStatusToMessageMap.VALID && (
              <LBCheckIcon className='size-6 text-success' />
            )}
          </>
        )}
        {loading && <CircularProgress size={26} />}
      </div>

      {loading && (
        <div className={`text-sm text-gray-600 ${inputClassName}`}>
          Validating...
        </div>
      )}

      {failurePayload && (
        <LBAlert variant='destructive' className={`my-2 ${inputClassName}`}>
          <LBAlertCircleIcon />
          <p>
            {failurePayload.message}
            <br />
            {failurePayload.missing_scopes ? (
              <>
                {failurePayload.missing_scopes.join(', ')}
                <br />
                please add them and try again
              </>
            ) : (
              ''
            )}
          </p>
        </LBAlert>
      )}
    </div>
  );
};

export default TokenValidator;
